import { render, staticRenderFns } from "./AccountMainDialog.vue?vue&type=template&id=2b4c3344&scoped=true&"
import script from "./AccountMainDialog.vue?vue&type=script&lang=js&"
export * from "./AccountMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c3344",
  null
  
)

export default component.exports